import SiteConfigs from '../../config/sites'

import { CustomMedia, windowMatchesMediaQuery } from '../utils/windowSize'

const initialState = {
  pageIsOffCanvas: false,
  pageCanvasDirection: null,
  isModalOpen: false,
  openModalType: null,
  openModalData: null,
  modalMessages: null,
  toggledPanelStates: {},
  panelOptionsCollapsed: ['tags', 'compatible-with', 'software-version'],
  selectedItem: null,
  offsetTop: null,
  isSidebarOpen: true
}

/**
 * UI state store action handler
 * @param  {Object} action Object
 * @param  {Object} state  Object
 * @return {Object} new State
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case 'toggleOffCanvas': {
      const direction = action.payload
      return {
        ...state,
        pageIsOffCanvas: !state['pageIsOffCanvas'],
        pageCanvasDirection: direction
      }
    }

    case 'closeModal':
      return {
        ...state,
        isModalOpen: false,
        openModalType: null,
        openModalData: null,
        modalMessages: null
      }

    case 'openModal': {
      const { type, payload } = action.payload
      return {
        ...state,
        isModalOpen: true,
        openModalType: type,
        openModalData: payload
      }
    }

    case 'showModalMessage':
      return {
        ...state,
        modalMessages: action.payload
      }

    case 'dismissModalMessage':
      return {
        ...state,
        modalMessages: null
      }

    case 'initToggledPanels': {
      const sessionToggledPanelStates =
        sessionStorage &&
        JSON.parse(sessionStorage.getItem('toggledPanelStates'))

      const isMobile = windowMatchesMediaQuery(CustomMedia.mediumAndBelow)
      const defaultToggledPanelStatesForMobile = {
        category: 'collapsed',
        tags: 'collapsed',
        price: 'collapsed',
        sales: 'collapsed',
        rating: 'collapsed',
        orientation: 'collapsed',
        'date-added': 'collapsed',
        sizes: 'collapsed',
        colors: 'collapsed',
        'software-version': 'collapsed',
        resolution: 'collapsed',
        'frame-rate': 'collapsed',
        'compatible-with': 'collapsed',
        'requires-plugins': 'collapsed',
        length: 'collapsed',
        vocals: 'collapsed',
        tempo: 'collapsed',
        polygons: 'collapsed',
        properties: 'collapsed',
        'include-pro-affiliated': 'collapsed',
        'file-formats': 'collapsed'
      }

      const initialToggledPanelStates = isMobile
        ? {
            ...sessionToggledPanelStates,
            ...defaultToggledPanelStatesForMobile
          }
        : { ...sessionToggledPanelStates }

      return {
        ...state,
        toggledPanelStates: initialToggledPanelStates
      }
    }

    case 'togglePanel': {
      const { toggledPanelStates } = state
      const { panelId, currentlyExpanded } = action.payload

      var newToggledPanelStates = { ...toggledPanelStates }

      newToggledPanelStates[panelId] = currentlyExpanded
        ? 'collapsed'
        : 'expanded'

      if (sessionStorage) {
        sessionStorage.setItem(
          'toggledPanelStates',
          JSON.stringify(newToggledPanelStates)
        )
      }

      return { ...state, toggledPanelStates: newToggledPanelStates }
    }

    case 'togglePanelOptions': {
      const { panelOptionsCollapsed } = state
      const panelId = action.payload

      const updatedOptions = panelOptionsCollapsed.includes(panelId)
        ? panelOptionsCollapsed.filter(panel => panel !== panelId)
        : [...panelOptionsCollapsed, panelId]

      return {
        ...state,
        panelOptionsCollapsed: updatedOptions
      }
    }

    case 'loadSiteConfigs': {
      const { currentSite } = action.payload

      const currentSiteConfig = SiteConfigs[currentSite]
      const isCurrentSiteSidebarOpen = !currentSiteConfig.hide_sidebar_by_default
      return { ...state, isSidebarOpen: isCurrentSiteSidebarOpen }
    }

    case 'toggleSidebar': {
      const { isSidebarOpen } = state

      return { ...state, isSidebarOpen: !isSidebarOpen }
    }

    case 'selectItem': {
      const { selectedItem } = state
      const item = action.payload

      let newSelectedItem =
        selectedItem && selectedItem.id === item.id ? null : item

      return { ...state, selectedItem: newSelectedItem }
    }

    case 'offsetTop': {
      const { offsetTop } = action.payload

      return { ...state, offsetTop }
    }

    default:
      return state
  }
}
